export const apiConfig = {
    API_END_POINT: "https://lead-api-gateway-5h8k489m.uc.gateway.dev/v1",
    REACT_APP_CRYPTOPASSWORD: process.env.REACT_APP_CRYPTOPASSWORD,
}
